import initialState from './settingInitialState';
import mutations from './settingMutation';
import actions from './settingAction';

const getters = {
  platformUsers: (state) => {
    const {
      platformUsers,
      selectedCorp,
    } = state;
    if (selectedCorp === 0) {
      return platformUsers;
    }
    const filtered = platformUsers.filter((pu) => pu.corporationId === selectedCorp);
    return filtered;
  },
  chargebeeCustomer: (state) => state.chargebeeCustomer,
};

const settingModule = {
  state: initialState(),
  mutations,
  actions,
  getters,
};

export default settingModule;
